import { useAppSelector, useAppDispatch } from 'store/hooks'
import { slices } from 'store/slices'
import Collection from './collection'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { ICollection } from 'interfaces/learningPath'

const Collections = () => {
  const dispatch = useAppDispatch()
  const content = useAppSelector(slices.learningPath.content)

  const onDragEnd = (result: any) => {
    const { destination, source } = result

    if (!destination || destination.index === source.index) {
      return
    }

    const newCollections = reorder(
      content.collections,
      source.index,
      destination.index
    )
    dispatch(slices.learningPath.updateCollectionsOrder(newCollections))
  }

  const reorder = (
    list: ICollection[],
    startIndex: number,
    endIndex: number
  ) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    return result
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {content.collections.map((collection, index) => (
              <Draggable
                key={index}
                draggableId={index.toString()}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={{ ...provided.draggableProps.style }}
                  >
                    <Collection
                      key={index}
                      collection={collection}
                      provided={provided}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export default Collections
